<div class="my-open-tasks">
  <div [formGroup]="form" class="grid grid-cols-3 gap-3 items-start">
    <mat-form-field class="col-span-2" >
      <mat-label>Task Types</mat-label>
      <mat-select
        formControlName="taskTypesSelection"
        multiple
      >
        @for (taskType of allowedTaskTypes(); track taskType.value) {
          <mat-option [value]="taskType.value">
            <mat-icon fontSet="material-symbols-outlined">{{ taskType.icon }}</mat-icon> {{ taskType.label }}
          </mat-option>
        }
      </mat-select>

    </mat-form-field>
    <div class="grid grid-cols-1 gap-1 w-full pb-2">
    <mat-radio-group formControlName="taskOwnership" class=" grid grid-cols-1 gap-2 w-full pb-2">
      <mat-radio-button value="my-tasks" class="text-sm">
        My Tasks
      </mat-radio-button>
      <mat-radio-button value="unassigned-tasks" class="text-sm">
        Unassigned Tasks
      </mat-radio-button>
    </mat-radio-group>
    </div>
  </div>

  <!-- List of open tasks -->
  <ri-resolution-ui-lazy-load-container
    [hasMoreItems]="hasGroupsToFetch()"
    (loadMoreItems)="loadTaskGroups()"
  >
    <ri-resolution-ui-sidebar-group-tasks
      class="block pt-2"
      [groups]="groups()"
      [showFetchButton]="hasGroupsToFetch()"
      (loadMore)="loadTaskGroups()"
    ></ri-resolution-ui-sidebar-group-tasks>

    <ng-template #message>
      <div class="p-3 text-center text-sm text-gray-500">
        @if (isLoading()) {
          Loading...
        } @else if (hasTasksLessThanLimit() && !hasGroupsToFetch()) {
          No additional tasks
          <div class="mt-2">
            <button
              mat-flat-button
              [disabled]="!autoAssignEnabled()"
              (click)="onAutoAssignTasks()"
            >
              Auto Assign Tasks
            </button>
          </div>
        } @else if (hasNoTasks()) {
          No Tasks
          <div class="mt-2">
            <button
              mat-flat-button
              [disabled]="!autoAssignEnabled()"
              (click)="onAutoAssignTasks()"
            >
              Auto Assign Tasks
            </button>
          </div>
        } @else if (!hasGroupsToFetch()) {
          No more tasks to load
        }
      </div>
    </ng-template>
  </ri-resolution-ui-lazy-load-container>
</div>
